import React, { FunctionComponent } from 'react';

import { Tag } from './styles';

export const tagColor: any = {
  4: 'purple',
  5: 'orange',
  6: 'yellow',
  7: 'green',
  12: 'pink',
  15: 'blue',
  16: 'grey',
};

const VehicleTag: FunctionComponent<{ tagClass: string; fastagColor: string; font?: string }> = (props: any) => (
  <div className="column">
    <Tag className={`tag smaller ${tagColor[props.tagClass]}`}>{props.tagClass}</Tag>
    <p className={`text-capitalized ${props.font || ''}`}>{`${props.fastagColor || '---'} Tag`}</p>
  </div>
);

export default VehicleTag;
